import { Offcanvas, Form, Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { stat } from "fs";
import { start } from "repl";

interface AddSubscriptionProps {
    show: boolean;
    handleClose: () => void;
    data?: any;
    //   activeTab: "ACTIVE" | "PENDING";
}

type FormData = {
    userId: string;
    planId: string;
    paymentstatus: "PAID" | "PENDING";
    startDate: string;
    endDate: string;
    notes?: string;
    paymentGatewayId?: string;
    status?: "ACTIVE" | "PENDING";
};

const AddSubscription = ({ show, handleClose, data }: AddSubscriptionProps) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<FormData>();

    const [isLoading, setLoading] = useState(false);
    const [orgList, setOrgList] = useState<any[]>([]);
    const [selectedOrg, setSelectedOrg] = useState<string>("");
    const [userList, setUserList] = useState<any[]>([]);
    const [planList, setPlanList] = useState<any[]>([]);

    // const isEdit = Boolean(data);

    const loadOrganizations = () => {
        WebService.getAPI({ action: "organizations/list-all" })
            .then((res: any) => setOrgList(res.data || []))
            .catch(() => setOrgList([]));
    };

    const loadUsers = () => {
        if (selectedOrg) {
            WebService.getAPI({ action: `users/list-all-by-org/${selectedOrg}` })
                .then((res: any) => setUserList(res.data || []))
                .catch(() => setUserList([]));
        } else {
            WebService.getAPI({ action: "users/list-all" })
                .then((res: any) => setUserList(res.data || []))
                .catch(() => setUserList([]));
        }
    };

    const loadPlans = () => {
        WebService.getAPI({ action: "plan/list-all" })
            .then((res: any) => setPlanList(res.data || []))
            .catch(() => setPlanList([]));
    };

    useEffect(() => {
        if (show) {
            loadOrganizations();
            loadPlans();

            const orgId = data || "";
            setSelectedOrg(orgId || "");
        }
    }, [show, data]);

    useEffect(() => {
        if (show) loadUsers();
    }, [selectedOrg]);

    const onSubmit = (formData: FormData) => {
        setLoading(true);
        const payload: any = {
            ...formData,
        };


        const apiCall = WebService.postAPI({
            action: "userSubscriptions/create",
            body: payload,
        });

        apiCall
            .then((res: any) => {
                toast.success(res.message || "Saved successfully!");
                handleClose();
                reset();
            })
            .catch((e) => toast.error(e?.response?.data?.message || "Error"))
            .finally(() => setLoading(false));
    };

    return (
        <Offcanvas
            show={show}
            placement="end"
            onHide={() => {
                handleClose();
                reset();
            }}
            className="offcanvas-custom"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Subscription</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
                <Form>
                    <Card className="p-3 mt-3">
                        <h6 className="fw-bold mb-3">Subscription Details</h6>

                        {/* ORGANIZATION */}
                        <Form.Group className="mb-3">
                            <Form.Label>Organization</Form.Label>
                            <Form.Select
                                value={selectedOrg}
                                onChange={(e) => setSelectedOrg(e.target.value)}
                            // disabled={isEdit}
                            >
                                <option value="">All Organizations</option>
                                {orgList.map((org) => (
                                    <option key={org._id} value={org._id}>
                                        {org.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        {/* USER */}
                        <Form.Group className="mb-3">
                            <Form.Label>User *</Form.Label>
                            <Form.Select {...register("userId", { required: "User is required" })}>
                                <option value="">Select User</option>
                                {userList.map((u) => (
                                    <option key={u._id} value={u._id}>
                                        {u.fullName || u.email}
                                    </option>
                                ))}
                            </Form.Select>
                            {errors.userId && <p className="text-danger">{errors.userId.message}</p>}
                        </Form.Group>

                        {/* PLAN */}
                        <Form.Group className="mb-3">
                            <Form.Label>Plan *</Form.Label>
                            <Form.Select
                                {...register("planId", { required: "Plan is required" })}
                            >
                                <option value="">Select Plan</option>
                                {planList.map((p) => (
                                    <option key={p._id} value={p._id}>
                                        {p.planName}
                                    </option>
                                ))}
                            </Form.Select>
                            {errors.planId && <p className="text-danger">{errors.planId.message}</p>}
                        </Form.Group>

                        {/* PAYMENT GATEWAY ID */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Gateway ID *</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter payment gateway ID"
                                {...register("paymentGatewayId", {
                                    required: true ? "Payment Gateway ID is required" : false,
                                })}
                            />
                            {errors.paymentGatewayId && (
                                <p className="text-danger">{errors.paymentGatewayId.message}</p>
                            )}
                        </Form.Group>

                        {/* STATUS */}
                        <Form.Group className="mb-3">
                            <Form.Label>Payment Status *</Form.Label>
                            <Form.Select
                                {...register("paymentstatus", { required: "Status is required" })}
                            >
                                <option value="PAID">PAID</option>
                                <option value="PENDING">PENDING</option>
                            </Form.Select>
                            {errors.paymentstatus && (
                                <p className="text-danger">{errors.paymentstatus.message}</p>
                            )}
                        </Form.Group>
                    </Card>

                    {/* DATES */}
                    <Card className="p-3 mt-3">
                        <h6 className="fw-bold mb-3">Dates</h6>

                        <Form.Group className="mb-3">
                            <Form.Label>Subscription Date *</Form.Label>
                            <Form.Control
                                type="date"
                                // disabled={isEdit}
                                {...register("startDate", { required: "Subscription date is required" })}
                            />
                            {errors.startDate && (
                                <p className="text-danger">{errors.startDate.message}</p>
                            )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Expiration Date *</Form.Label>
                            <Form.Control
                                type="date"
                                // disabled={isEdit}
                                {...register("endDate", { required: "Expiration date is required" })}
                            />
                            {errors.endDate && (
                                <p className="text-danger">{errors.endDate.message}</p>
                            )}
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Status *</Form.Label>
                            <Form.Select
                                {...register("status", { required: "Status is required" })}
                            >
                                <option value="ACTIVE">ACTIVE</option>
                                <option value="PENDING">PENDING</option>
                            </Form.Select>
                            {errors.status && (
                                <p className="text-danger">{errors.status.message}</p>
                            )}
                        </Form.Group>
                    </Card>

                    {/* NOTES */}
                    <Card className="p-3 mt-3">
                        <h6 className="fw-bold mb-2">Notes</h6>
                        <Form.Control as="textarea" rows={3} {...register("notes")} />
                    </Card>
                </Form>
            </Offcanvas.Body>

            <div className="p-3">
                <CustomButton
                    isLoading={isLoading}
                    label={"Save"}
                    className="w-100"
                    onClick={handleSubmit(onSubmit)}
                />
            </div>
        </Offcanvas>
    );
};

export default AddSubscription;
